import { memoizeWith, identity } from 'ramda';
function getCustomTooltipThemeStyles(theme) {
  return require("./".concat(theme, ".module.css"));
}
export const getThemeStyles = memoizeWith(identity, getCustomTooltipThemeStyles);